export * from './InternetSpeedModal';
